export default __webpack_public_path__ + "static/media/spark_73.cc9a7f24.png";